<template>
  <div data-v-03b1ba29="" class="payment-method dekbox" style="padding-bottom: 20px">
    <div class="demain">
      <div data-v-03b1ba29="" class="topup-title">
        <span data-v-03b1ba29="" style="font-size: 18px">{{ $t('_txsq._bz') }}</span>
      </div>
      <div data-v-03b1ba29="" class="vip-wrapper">
        <div data-v-03b1ba29="" :class="['vip-item', currencyIndex == i ? 'active' : '']" v-for="(vo, i) in currencyList" :key="i" @click="onCurrencyChange(i)">
          <div data-v-03b1ba29="" class="vip-item-left">
            <div data-v-03b1ba29="" class="vip-item-top">
              <span data-v-03b1ba29="" class="vip-item-title">{{ vo.text }}</span>
              <div data-v-03b1ba29="" class="vip-item-price-wrapper">
                <img :src="require('../../static/img_icon/' + vo.text.toLowerCase() + '.png')" style="width: 40px" />
              </div>
            </div>
          </div>
          <!-- <div data-v-03b1ba29="" class="vip-item-mark vip-item-mark-1"
                                    style="background: rgb(251, 56, 103);">
                                    <span data-v-03b1ba29="">Super Value</span>
                                </div>
                                <div data-v-03b1ba29="" class="vip-item-bg oss-image-wrapper vip-item-bg"
                                    style="background: url(&quot;https://file-cdn..cc/image/43/60e5fb25b9272e6509a18236e68575.png?image_process=resize,w_110/quality,Q_75/format,webp&quot;) center top / 100% no-repeat;">
                                </div> -->
        </div>
      </div>

      <div data-v-03b1ba29="" class="payment-wrapper">
        <span data-v-03b1ba29="" class="payment-title">{{ $t('_txsq._wl') }}</span>
        <div data-v-03b1ba29="" class="payment-item-wrapper">
          <div data-v-03b1ba29="" :class="['payment-item', protocolIndex == i ? 'active' : '']" v-for="(vo, i) in protocolList" :key="i" @click="onProtocolClick(i)">
            <div>{{ vo.network }}</div>
          </div>
        </div>
      </div>

      <div data-v-03b1ba29="" class="payment-wrapper">
        <span data-v-03b1ba29="" class="payment-title">{{ $t('_txsq._ye') }}</span>
        <div data-v-03b1ba29="" class="payment-item-wrapper">
          <div>{{ balance }} {{ current.name }}</div>
        </div>
      </div>

      <div data-v-03b1ba29="" class="payment-wrapper">
        <span data-v-03b1ba29="" class="payment-title">{{ $t('_txsq._sxf') }}</span>
        <div data-v-03b1ba29="" class="payment-item-wrapper">
          <div>≈ {{ fee }} {{ current.name }}</div>
        </div>
      </div>
      <div data-v-03b1ba29="" class="payment-wrapper">
        <span data-v-03b1ba29="" class="payment-title">{{ $t('_txsq._zxtx') }}</span>
        <div data-v-03b1ba29="" class="payment-item-wrapper">
          <div>≈ {{ transfer_min }} {{ current.name }}</div>
        </div>
      </div>

      <div data-v-03b1ba29="" class="payment-wrapper">
        <span data-v-03b1ba29="" class="payment-title">{{ $t('_txsq._txdz') }}</span>
        <div data-v-03b1ba29="" class="payment-item-wrapper">
          <div data-v-03b1ba29="" class="select-wrapper">
            <select class="select-box" @change="onAddressChange">
              <option value="">{{ $t('_txsq._qxztxdz') }}</option>
              <option v-for="(vo, i) in current.address_list" :key="i" :value="vo.value">
                {{ vo.value }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div data-v-03b1ba29="" class="payment-wrapper">
        <span data-v-03b1ba29="" class="payment-title">{{ $t('_txsq._txje') }}</span>
        <div data-v-03b1ba29="" class="payment-item-wrapper">
          <input v-model="params.number" type="text" class="input-box" :placeholder="$t('_txsq._qsrtxje')" />
        </div>
      </div>

      <div data-v-03b1ba29="" class="payment-wrapper" v-if="user.is_moni == 1">
        <span data-v-03b1ba29="" class="payment-title">{{ $t('_txsq._yxyzm') }}</span>
        <div data-v-03b1ba29="" class="payment-item-wrapper iptbox">
          <input v-model="params.code" type="text" class="input-box" :placeholder="$t('_txsq._qsryxyzm')" />
          <div>
            <button @click="onSendCode">{{ codeBtnText }}</button>
          </div>
        </div>
      </div>

      <div data-v-03b1ba29="" class="payt-footer btnc">
        <button data-v-03b1ba29="" class="payment-btn" @click="onSubmit()">
          <span data-v-03b1ba29="">{{ $t('_txsq._ljtx') }}</span>
        </button>

        <button data-v-03b1ba29="" class="payment-btn btnf" @click="onBack('wallet')">
          <span data-v-03b1ba29="">{{ $t('_sp._fanh') }}</span>
        </button>
      </div>

      <!-- <div data-v-03b1ba29="" class="tips-wrapper">
        <div data-v-982acdfa="" data-v-03b1ba29="" class="tips">
          <p data-v-982acdfa="">Tips:</p>
          <p data-v-982acdfa="">1. ReelShortPro has free and paid content for everyone. You decide which content to unlock</p>
          <p data-v-982acdfa="">2. Coins will be used to unlock paid content</p>
          <p data-v-982acdfa="">3. Refill coins and bonus are equal value. Recharge does not support refund</p>
          <p data-v-982acdfa="">4. If you have other problems, please contact us</p>
        </div>
      </div> -->
    </div>
  </div>
  <!-- <div data-v-4490912c="" data-v-03b1ba29="" class="loading" style="display: none;"><img
                            data-v-4490912c="" src="https://www..cc/_nuxt/loading.Czr7mSn8.png"></div> -->
</template>

<script>
import { countdown } from '@/utils/tools'
export default {
  name: 'depositVue',
  data() {
    return {
      currencyList: [],
      currencyIndex: 0,

      protocolList: [],
      protocolIndex: 0,
      current: {},

      user: {},

      //参数
      params: {
        address: '',
        number: '',
        code: ''
      },

      isload: false,
      c_name: '',
      balance: 0,
      fee: '0.00',
      fee_max: '0.00',
      fee_min: '0.00',
      transfer_min: '0.001',

      hasSend: true,
      codeBtnText: this.$t('_yzm._fsyzm')
    }
  },
  created() {
    this.getCurrencyList()
    this.user = this.$common.getInfo()
    // console.log(this.user)
  },
  methods: {
    onBack(name) {
      this.$router.push({ name: name })
    },
    getCurrencyList() {
      let that = this
      this.$api.chain.getCurrencyList().then((res) => {
        that.currencyList = res.data
        //默认第一个
        that.onCurrencyChange(that.currencyIndex)
      })
    },
    onCurrencyChange(i) {
      this.currencyIndex = i
      this.protocolList = this.currencyList[i].protocol
      this.onProtocolClick(0)
    },

    // 点击协议
    onProtocolClick(i) {
      this.protocolIndex = i
      this.params.address = undefined
      this.current = this.protocolList[i]
      if (this.current.address_list == null) {
        this.current.address_list = undefined
      }

      //当前协议
      this.c_name = this.current.name + '_' + this.current.network
      //this.onNumber();

      //24小时限额
      //this.transfer_24_max = parseFloat(this.current.transfer_24_max)

      //最小提现
      // this.transfer_min = parseFloat(this.current.transfer_min)

      //随机抽取费率
      this.fee_max = parseFloat(this.current.transfer_fee_max)
      this.fee_min = parseFloat(this.current.transfer_fee_min)

      //缓存生成费用
      this.setCache()

      //当前余额
      this.balance = parseFloat((parseFloat(this.current.wallet.number) - this.fee).toFixed(8))
      if (this.balance < 0) {
        this.balance = 0
      }

      //this.onNumber()
      console.log(this.current)
    },
    setCache() {
      console.log(this.c_name)
      const k1 = this.c_name + '_tv_fee'
      const k2 = this.c_name + '_tv_fee_t'

      // 修复：正确处理 localStorage 数据
      let feeData = localStorage.getItem(k1)

      // 检查是否是 JSON 字符串
      if (feeData && feeData.startsWith('{')) {
        try {
          const parsed = JSON.parse(feeData)
          this.fee = parsed.data || parsed // 根据实际结构调整
        } catch (e) {
          this.fee = parseFloat(feeData) || this.generateNewFee()
        }
      } else {
        this.fee = parseFloat(feeData) || this.generateNewFee()
      }

      const o = localStorage.getItem(k2)
      const n = parseInt(new Date().getTime() / 1000)
      let t = parseInt(o - n)
      if (t < 0) {
        this.fee = this.generateNewFee()
        // 修复：明确存储为数字字符串
        localStorage.setItem(k1, this.fee.toString())
        localStorage.setItem(k2, (n + 60).toString())
      }
    },
    // 提取费用生成逻辑
    generateNewFee() {
      return parseFloat((Math.random() * (this.fee_max - this.fee_min) + this.fee_min).toFixed(6))
    },
    valid() {
      if (this.params.address === '' || this.params.address === undefined) {
        this.$message.warning({ content: this.$t('_txsq._qxztxdz'), key: 'msg' })
        return false
      }

      if (this.params.number === '') {
        this.$message.warning({ content: this.$t('_txsq._qsrtxje'), key: 'msg' })
        return false
      }

      if (this.params.code === '' && this.user.is_moni == 1) {
        this.$message.warning({ content: this.$t('_txsq._qsryxyzm'), key: 'msg' })
        return false
      }

      return true
    },
    // 币种改变
    onAddressChange(e) {
      console.log(e.target.value)
      this.params.address = event.target.value
    },
    /**
     * 提交提现
     * @param {*} values
     */
    onSubmit() {
      console.log('params:', this.params)

      if (!this.valid()) {
        return
      }

      if (this.isload) {
        return
      }
      this.isload = true

      var hide = this.$message.loading({ content: this.$t('_a._jzz'), key: 'msg' })

      //参数
      this.params.c_id = this.current.id
      this.params.wallet_id = this.current.wallet.id
      this.params.fee = Number(this.fee)
      this.params.number = Number(this.params.number)

      let that = this
      this.$api.userWallet
        .withdraw(this.params)
        .then((res) => {
          hide()
          this.isload = false

          if (res.code == 1) {
            this.$message.warning({ content: res.msg, key: 'msg' })
            return
          }

          if (res.code == 1) {
            that.msgTitle = res.msg
            that.$refs.toast.open()
            return
          }

          //关闭弹窗，重新刷新
          // that.getWithdrawalList();
          this.$message.success({ content: res.msg, key: 'msg' })

          setTimeout(function () {
            that.$router.push({ name: 'wallet', query: { i: 5 } })
          }, 500)
        })
        .catch((res) => {
          that.isload = false
          this.$message.warning({ content: res.msg, key: 'msg' })
        })
    },
    onAll() {
      this.params.number = this.balance
      // this.onNumber();
    },
    /**
     * 发送验证码
     */
    onSendCode() {
      if (!this.hasSend) {
        return
      }

      let key = this.$md5('withdraw')

      this.$message.loading({ content: this.$t('_yzm._fsz'), key: 'msg' })

      let that = this
      this.$api.code
        .sendCode({
          scene: 'withdraw'
        })
        .then((res) => {
          if (res.code == 1) {
            this.$message.warning({ content: res.msg, key: 'msg' })
            return
          }

          this.$message.success({ content: this.$t('_yzm._fscg'), key: 'msg' })
          countdown.start(key, res.data.exp)
          countdown.run(key, that.CallTime)
        })
    },
    /**
     * 倒计时回调
     * @param {*} time
     */
    CallTime(time) {
      console.log(time)
      if (time == 0) {
        this.hasSend = true
        this.codeBtnText = this.$t('_yzm._fsyzm')
      } else {
        this.hasSend = false
        this.codeBtnText = this.$t('_yzm._cxfs', {
          time: time
        })
      }
    }
  }
}
</script>
<style scoped>
@import url('../../static/css_deposit/index.B4UqQ7MX.css');
</style>
<style>
.dekbox {
  padding-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.demain {
  width: 1200px;
}

.record-a {
  padding-top: 36px;
}

.select-box {
  width: 500px;
  height: 40px;
  border: 1px solid #212325;
  padding: 10px;
  border-radius: 10px;

  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  outline: none;
  background: #0b0d0f !important;
  color: #fff;
}

.select-box:focus {
  /* border-color: #4a6cf7; */
  box-shadow: 0 0 0 3px rgba(74, 108, 247, 0.2);
}

.select-wrapper::after {
  content: '';
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  width: 15px;
  height: 15px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: center;
  pointer-events: none;
  transition: transform 0.3s ease;
}

.select-wrapper {
  position: relative;
}

.input-box {
  width: 300px;
  height: 40px;
  border: 1px solid #212325;
  padding: 10px;
  border-radius: 10px;
  background: #0b0d0f !important;
  color: #fff;
}

.input-box:focus {
  border-color: #212325;
  color: #fff;
  box-shadow: 0 0 0 3px rgba(74, 108, 247, 0.2);
  outline: none;
}

.iptbox {
  display: flex;
  align-items: center;
  gap: 20px;
}

.payt-footer {
  /* background-color: #fff; */
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  margin-top: 24px;
  padding: 10px 0;
  /* position: sticky; */
  right: 0;
}

.payt-footer .payment-btn {
  background: #fb3867;
  border-radius: 32px;
  color: #fff;
  font-family: Ubuntu-Bold;
  font-size: 16px;
  font-weight: 700;
  height: 48px;
  width: 512px;
}
</style>
